import React from 'react';
import { Navigate } from 'react-router-dom';
import { bool, node, string } from 'prop-types';

const PermissionsRolesGuard = ({ authCondition, children, redirect }) =>
  authCondition ? children : <Navigate replace to={redirect} />;

PermissionsRolesGuard.propTypes = {
  authCondition: bool.isRequired,
  children: node.isRequired,
  redirect: string,
};

PermissionsRolesGuard.defaultProps = {
  redirect: '/',
};

export default PermissionsRolesGuard;
